const paths = {
  listTrigger: '/schedule/trigger',
  listShift: '/schedule/shift'
};

export default paths;
